module.exports = __webpack_public_path__ + "img/shop-text.0a0ab3a9.svg";